import { Grid, makeStyles, Theme, Typography } from "@material-ui/core";
import React, { FunctionComponent } from "react";
import { DARK_TEXT_COLOR } from "../../../../theme/theme";

const useStyles = makeStyles((theme: Theme) => ({
  heading: {
    fontSize: 21,
    width: "100%",
    whiteSpace: "break-spaces",
    color: DARK_TEXT_COLOR,
    fontWeight: 700,
  },
}));

interface IOnboardingHeadingProps {}

export const OnboardingHeading: FunctionComponent<IOnboardingHeadingProps> = (props) => {
  const classes = useStyles();
  return (
    <Grid item>
      <Typography className={classes.heading}>{props.children}</Typography>
    </Grid>
  );
};
